// src/pages/bi/DashboardScoringIA.jsx - VERSION SIMPLE
import React from 'react';
import Layout from '../../components/Layout';
import KPIsSection from '../../services/bi/KPIsSection';
import AnalyticsSection from '../../services/bi/AnalyticsSection';
import PriorityFormationsSection from '../../services/bi/PriorityFormationsSection';
import WeekRangePicker from '../../components/bi/WeekRangePicker';
import '../../styles/bi/dashboardScoringIA.css';
import '../../styles/bi/analyticsRecommendations.css';
import '../../styles/bi/priorityFormations.css';

const DashboardScoringIA = () => {
  return (
    <Layout>
      <div className="dashboard-scoring-ia">
        {/* Header */}
        <div className="dashboard-header">
          <div className="dashboard-header__container">
            <div className="dashboard-header__content">
              <div>
                <h1 className="dashboard-header__title">
                  Dashboard Scoring IA
                </h1>
                <p className="dashboard-header__subtitle">
                  Système intelligent d'aide à la décision commerciale
                </p>
              </div>
              
              {/* Affichage simple de la date de semaine */}
              <WeekRangePicker />
            </div>
          </div>
        </div>

        {/* Contenu principal */}
        <main className="dashboard-main">
          {/* Section 1 — KPIs */}
          <section className="dashboard-section">
            <KPIsSection />
          </section>

          {/* Section 2 — Analytics & Recommandations */}
          <section className="dashboard-section">
            <AnalyticsSection />
          </section>

          {/* Section 3 — Formations prioritaires */}
          <section className="dashboard-section priority-section-wrapper">
            <PriorityFormationsSection />
          </section>
        </main>
      </div>
    </Layout>
  );
};

export default DashboardScoringIA;